import { skipToken, useQuery } from "@tanstack/react-query";

import { fetchMatchingUnreadNotificationCount } from "./fetchNotifications";
import { notificationQueryKeys } from "./query-keys";
import { NOTIFICATION_STALE_TIME_MS } from "../constants";
import type { MatchingUnreadCountParams } from "../types";

export function useMatchingUnreadCount(params: MatchingUnreadCountParams | null) {
  return useQuery({
    queryKey: notificationQueryKeys.matchingUnreadCount(params),
    queryFn: params ? () => fetchMatchingUnreadNotificationCount(params) : skipToken,
    staleTime: NOTIFICATION_STALE_TIME_MS,
  });
}
